<template>
    <section class="row models-wrapper">
        <article
            v-for="index in 6"
            :key="`${index}-skeleton-card`"
            class="w-100"
        >
            <ob1-cards>
                <div class="d-flex flex-column h-100 justify-content-between">
                    <div class="ob1-skeleton p-1">
                        <div class="ob1-skeleton-white mb-1" style="width: 140px; height: 30px" />
                        <div class="d-flex">
                            <div class="ob1-skeleton-white" style="width: 140px; height: 175px" />
                            <div class="ms-1 mobile-infos" style="width: 140px">
                                <div class="ob1-skeleton-white" style="height: 45px" />
                                <div class="ob1-skeleton-white mt-1" style="height: 25px" />
                                <div class="ob1-skeleton-white mt-1" style="height: 45px" />
                            </div>
                        </div>
                        <div class="ob1-skeleton-white mt-1" style="height: 40px" />
                    </div>
                </div>
            </ob1-cards>
        </article>
    </section>
</template>

<script>
export default {
    name: "SkeletonSelectorCard",
}
</script>
